import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { StyledEngineProvider } from '@mui/material/styles'

import { store } from './app/store'
import { AuthProvider } from './features/user/AuthProvider'
import './scss/index.scss'
import { Loading } from './components/common'
import AuthGate from './features/user/AuthGate'
import AppRouter from './routes/AppRouter'
import { DynamicThemeProvider } from './DynamicThemeProvider'

let persistor = persistStore(store)

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate
        loading={
          <Loading
            fullscreen
            loading={true}
            message="Loading app state..."
            sx={{ color: '#f5f5f3' }}
          />
        }
        persistor={persistor}
      >
        <StyledEngineProvider injectFirst>
          <DynamicThemeProvider>
            <AuthProvider>
              <AuthGate>
                <AppRouter />
              </AuthGate>
            </AuthProvider>
          </DynamicThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
